import BaseClient from '@/app/model/api/response/baseApiClient'

class MypagePutKeyApi extends BaseClient {
  public doKeyChange (bodyData: {[key: string]: string}) {
    const path = '/v1/company/apikey'

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'PUT')
  }
}

export default new MypagePutKeyApi()
